import { Outlet } from 'react-router-dom';
import { ThemeMenuButton } from '@/shared/components/ThemeMenuButton';

/**
 * Posições dos retângulos decorativos do painel esquerdo, em px, exatamente
 * como no Figma (FGP, nó 7014:178473 — frame de 640×800).
 */
const DECOR_POSITIONS: ReadonlyArray<{ left: number; top: number }> = [
  { left: 127, top: -99 },
  { left: 127, top: 493 },
  { left: -289, top: -99 },
  { left: -289, top: 197 },
  { left: -289, top: 493 },
  { left: 543, top: -99 },
  { left: 543, top: 197 },
  { left: 543, top: 493 },
];

/**
 * Shell das telas públicas (Figma FGP 7014:175843).
 * Desktop (lg+): split-screen 50/50 — ilustração à esquerda, formulário à direita.
 * Tablet/mobile: só o formulário, em coluna única.
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-screen font-source">

      {/* ── Painel esquerdo: ilustração — só em lg+ ────────────────────────── */}
      <div
        aria-hidden="true"
        className="relative hidden w-1/2 shrink-0 items-center justify-center overflow-hidden bg-sidebar px-16 py-12 lg:flex"
      >
        {/* Grade decorativa de 640×800 centralizada, para ficar alinhada à ilustração em qualquer altura */}
        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[800px] w-[640px] -translate-x-1/2 -translate-y-1/2">
          {DECOR_POSITIONS.map(({ left, top }) => (
            <div
              key={`${left}-${top}`}
              className="absolute h-[265.776px] w-[385.635px] rounded-[40px] bg-auth-decor opacity-[0.08] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]"
              style={{ left, top }}
            />
          ))}
        </div>

        <img
          src="/auth/illustration.svg"
          alt=""
          className="relative aspect-[512/382.717] w-full max-w-[512px]"
        />
      </div>

      {/* ── Painel direito: formulário — sempre visível ────────────────────── */}
      <div className="relative flex flex-1 flex-col items-center justify-center bg-surface px-6 py-10 sm:px-16 sm:py-12">
        <ThemeMenuButton
          containerClassName="absolute right-6 top-6"
          className="text-ink-muted hover:bg-hover"
          menuClassName="bottom-auto top-full right-0 left-auto mt-2 mb-0 translate-x-0"
        />
        <div className="w-full max-w-[512px]">
          <Outlet />
        </div>
      </div>

    </div>
  );
}
